module.exports = __webpack_public_path__ + "static/media/img_6.320ac000.png";